import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import Auth from '../utils/auth.js';

const auth = new Auth();

class Logout extends Component {

  constructor(props, context) {
    super(props, context)
    this.logout = this.logout.bind(this)
  }

  logout() {
    auth.logout();
  }

  render() {
    return (
      <Grid>
        <Row>
          <Col smOffset={3} sm={6}><h1 className="login-header">Fantasy Fitness Draft</h1></Col>
        </Row>
        <Row className="login-button">
          <Col smOffset={4} sm={4}>
            <a className="btn btn-block btn-social btn-lg btn-facebook" onClick={this.logout}>Sign out of FFD</a>
          </Col>
        </Row>
        <Row className="login-button">
          <Col smOffset={4} sm={4}>
            <p>&nbsp;</p>
            <h4 className="login-text">“You don’t train to picture yourself second place on the podium. Second place sucks.”</h4>
            <h4 className="login-text">- Mat Fraser, Fittest Man on Earth, 2016 Reebok CrossFit Games</h4>
          </Col>
        </Row>
      </Grid>
    );
  }

}

export default Logout;



// WEBPACK FOOTER //
// ./src/components/Logout.js